import { render } from "./TabLink.vue?vue&type=template&id=6bee39b5&scoped=true&ts=true"
import script from "./TabLink.vue?vue&type=script&lang=ts"
export * from "./TabLink.vue?vue&type=script&lang=ts"

import "./TabLink.vue?vue&type=style&index=0&id=6bee39b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bee39b5"]])

export default __exports__